import React from 'react';
import { flexRender, Table } from '@tanstack/react-table';
import { Table as MuiTable, TableHead, TableRow, TableCell, TableBody } from '@mui/material';

interface DataTableProps<T> {
  table: Table<T>;
}

const DataTable = <T,>({ table }: DataTableProps<T>) => {
  return (
    <div className="table-responsive">
      {/* <MuiTable
        className="datatable"
        style={{ tableLayout: "fixed" }}
        sx={{
          borderCollapse: "collapse",
          '& th': {
            position: 'relative',
            userSelect: 'none',
            borderRight: 'none !important',
          },
        }}
      >
        <TableHead>
          {table.getHeaderGroups().map(headerGroup => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map(header => (
                <TableCell
                  key={header.id}
                  style={{
                    width: header.getSize(),
                    minWidth: header.getSize(),
                    maxWidth: header.getSize(),
                    padding: "8px",
                  }}
                >
                  {!header.isPlaceholder &&
                    flexRender(header.column.columnDef.header, header.getContext())}
                  {header.column.getCanResize() && (
                    <div
                      {...{
                        onMouseDown: header.getResizeHandler(),
                        onTouchStart: header.getResizeHandler(),
                        style: {
                          position: "absolute",
                          right: 0,
                          top: "25%",
                          height: "50%",
                          width: "4px",
                          cursor: "col-resize",
                          userSelect: "none",
                          touchAction: "none",
                          backgroundColor: "#aaa", // always visible gray bar
                          borderRadius: "2px",
                          zIndex: 10,
                          transition: "background-color 0.2s",
                        },
                        className: header.column.getIsResizing() ? "isResizing" : "",
                      }}
                    />
                  )}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {table.getRowModel().rows.map(row => (
            <TableRow key={row.id}>
              {row.getVisibleCells().map(cell => (
                <TableCell
                  key={cell.id}
                  style={{
                    width: cell.column.getSize(),
                    minWidth: cell.column.getSize(),
                    maxWidth: cell.column.getSize(),
                    padding: "8px",
                    borderRight: "none",
                    borderLeft: "none",
                  }}
                >
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable> */}
      <MuiTable
        className="datatable"
        sx={{
          borderCollapse: "collapse",
          '& th': {
            borderRight: 'none !important',
          },
        }}
      >
        <TableHead>
          {table.getHeaderGroups().map((headerGroup) => (
            <TableRow key={headerGroup.id}>
              {headerGroup.headers.map((header) => (
                <th key={header.id}>
                  {header.isPlaceholder
                    ? null
                    : flexRender(
                        header.column.columnDef.header,
                        header.getContext()
                      )}
                </th>
              ))}
            </TableRow>
          ))}
        </TableHead>
        <TableBody>
          {table.getRowModel().rows.map((row) => (
            <TableRow key={row.id}>
              {row.getVisibleCells().map((cell) => (
                <TableCell key={cell.id} sx={{ borderRight: 'none', borderLeft: 'none' }}>
                  {flexRender(cell.column.columnDef.cell, cell.getContext())}
                </TableCell>
              ))}
            </TableRow>
          ))}
        </TableBody>
      </MuiTable>
    </div>
  );
};

export default DataTable;
